import React from "react";
import { useLocation } from 'react-router-dom';

const ArticleWrapper = ({ articles }) => {

    // Get selected article from url
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const article = query.get('article');

    // Load selected article
    const SelectedArticle = (articles.find(a => a.key === article))?.value;

    return (
        <div>
            {SelectedArticle ? SelectedArticle : null}
        </div>
    );
}

export default ArticleWrapper;
